import { DateTime } from 'luxon';
import { ReservationEventTypes } from '@common/models/Enums';

export interface IAppointmentAuditLogModel {
  reservationId: number;
  dateCreated: string;
  type: string;
  event: string;
  initiator: string;
  note: string;
  relatedReservationDate: string | undefined;
  uiEventName: string;
}

export class AppointmentAuditLogModel
  implements Record<keyof IAppointmentAuditLogModel, any>
{
  reservationId: number;
  dateCreated: DateTime;
  type: string;
  event: string;
  initiator: string;
  note: string;
  relatedReservationDate: DateTime | undefined;
  uiEventName: string;

  // not making this a partial constructor because these objects are read-only from the API.
  constructor(params: IAppointmentAuditLogModel, timezone: string) {
    this.reservationId = params.reservationId;
    this.dateCreated = DateTime.fromISO(params.dateCreated, {
      zone: 'utc',
    }).setZone(timezone);
    this.type = params.type;
    this.event = params.event;
    this.initiator = params.initiator;
    this.note = params.note;
    this.relatedReservationDate = params.relatedReservationDate
      ? DateTime.fromISO(params.relatedReservationDate, {
          zone: timezone,
        }).setZone(timezone)
      : undefined;
    this.uiEventName =
      this.event === ReservationEventTypes.RescheduledFrom
        ? 'Rescheduled'
        : this.event;
  }
}
